import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper-client" }
const _hoisted_3 = { class: "wrapper-form" }
const _hoisted_4 = { class: "wrapper-check" }
const _hoisted_5 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_AdminSelect = _resolveComponent("AdminSelect")!
  const _component_AdminInput = _resolveComponent("AdminInput")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      title: _ctx.isEmpty ? 'Crear cliente' : 'Editar cliente'
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AdminSelect, {
          options: _ctx.idTypeList,
          id: 'IdType',
          text: _ctx.identificationType.val,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.identificationType.val) = $event)),
          value: _ctx.identificationType.val,
          label: 'Tipo de identificación',
          "has-error": _ctx.identificationType.enabled,
          error: _ctx.identificationType.errors[0] ?? '',
          "is-disabled": _ctx.isEdit
        }, null, 8, ["options", "text", "value", "has-error", "error", "is-disabled"]),
        _createVNode(_component_AdminInput, {
          text: _ctx.identificationNumber.val,
          "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.identificationNumber.val) = $event)),
          value: _ctx.identificationNumber.val,
          label: 'Número de identificación',
          "has-error": _ctx.identificationNumber.enabled,
          error: _ctx.identificationNumber.errors[0] ?? '',
          "is-disabled": _ctx.isEdit
        }, null, 8, ["text", "value", "has-error", "error", "is-disabled"]),
        _createVNode(_component_AdminInput, {
          text: _ctx.company.val,
          "onUpdate:text": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company.val) = $event)),
          value: _ctx.company.val,
          label: 'Nombre de la empresa',
          "has-error": _ctx.company.enabled,
          error: _ctx.company.errors[0] ?? ''
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_AdminInput, {
          text: _ctx.contactName.val,
          "onUpdate:text": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactName.val) = $event)),
          value: _ctx.contactName.val,
          label: 'Nombre de la persona de contacto',
          "has-error": _ctx.contactName.enabled,
          error: _ctx.contactName.errors[0] ?? ''
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_AdminInput, {
          text: _ctx.contactEmail.val,
          "onUpdate:text": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactEmail.val) = $event)),
          value: _ctx.contactEmail.val,
          label: 'Correo electrónico de contacto',
          "has-error": _ctx.contactEmail.enabled,
          error: _ctx.contactEmail.errors[0] ?? ''
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createVNode(_component_AdminInput, {
          text: _ctx.contactPhone.val,
          "onUpdate:text": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contactPhone.val) = $event)),
          value: _ctx.contactPhone.val,
          label: 'Número de teléfono de contacto',
          "has-error": _ctx.contactPhone.enabled,
          error: _ctx.contactPhone.errors[0] ?? ''
        }, null, 8, ["text", "value", "has-error", "error"]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "check",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isSameEmail) = $event)),
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleEmailCheckboxChange && _ctx.handleEmailCheckboxChange(...args)))
          }, null, 544), [
            [_vModelCheckbox, _ctx.isSameEmail]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("p", null, "Correo electrónico de contacto es el mismo de facturación", -1))
        ]),
        _createVNode(_component_AdminInput, {
          text: _ctx.billingEmail.val,
          "onUpdate:text": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.billingEmail.val) = $event)),
          value: _ctx.billingEmail.val,
          label: 'Correo electrónico de facturación',
          "has-error": _ctx.billingEmail.enabled,
          error: _ctx.billingEmail.errors[0] ?? '',
          "is-disabled": _ctx.isSameEmail
        }, null, 8, ["text", "value", "has-error", "error", "is-disabled"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Cancelar',
          isCancel: true,
          onClick: _ctx.backClientsOption
        }, null, 8, ["onClick"]),
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Guardar',
          "is-disabled": _ctx.successForm,
          onClick: _ctx.createEditTransactionRouter
        }, null, 8, ["is-disabled", "onClick"])
      ])
    ])
  ]))
}